<template>
  <div id="banner">
    <!-- 导航1 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学生体验管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容2 -->
    <div class="content">
      <!-- 搜索框sel2.1 -->
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <!-- <el-button type="success" @click="addClick()">新增</el-button> -->
        </el-form-item>
      </el-form>
      <!-- 列表框2.2 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>学生体验列表</span>
        </div>
        <el-tabs v-model="query.state" @tab-click="getList">
          <el-tab-pane
            v-for="item in statelist"
            :label="item.name"
            :key="item.id"
            :name="item.id.toString()"
          ></el-tab-pane>
        </el-tabs>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="stuName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="isApplyFill" label="是否填写申请体验">
            <template slot-scope="sc">
              <el-tag v-if="sc.row.isApplyFill" type="success">是</el-tag>
              <el-tag v-else type="warn">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="applyFillName"
            label="申请体验填写人"
          ></el-table-column>
          <el-table-column
            prop="applyFillTime"
            label="申请体验填写时间"
          ></el-table-column>

          <template v-if="query.state == 'a'">
            <el-table-column prop="isHeighFill" label="是否填写升学体验">
              <template slot-scope="sc">
                <el-tag v-if="sc.row.isHeighFill" type="success">是</el-tag>
                <el-tag v-else type="warn">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="heighFillName"
              label="升学体验填写人"
            ></el-table-column>
            <el-table-column
              prop="heighFillTime"
              label="升学体验填写时间"
            ></el-table-column>
          </template>

          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑申请体验" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row, 1)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑升学体验" placement="top" v-if="scope.row.state=='a'">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-search"
                    @click="editClick(scope.row, 2)"
                  ></el-button> </el-tooltip
              ></el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页条page -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 编辑申请体验 -->
    <el-dialog
      :title="form.id > 0 ? '编辑申请体验' : '添加申请体验'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form, 1)"
      >
        <el-form-item label="申请体验" prop="applyContent">
          <vue-ueditor-wrap
            v-model="form.applyContent"
            :config="editorConfig"
          ></vue-ueditor-wrap>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑升学体验 -->
    <el-dialog
      :title="form.id > 0 ? '编辑升学体验' : '添加升学体验'"
      :visible.sync="heighDialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form, 2)"
      >
        <el-form-item label="升学体验" prop="heighContent">
          <vue-ueditor-wrap
            v-model="form.heighContent"
            :config="editorConfig"
          ></vue-ueditor-wrap>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="heighDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  components: { VueUeditorWrap },
  data() {
    return {
      domain: url.getDomain(),
      editorConfig: {
        initialFrameHeight: 500, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      query: { state: "a" },
      form: {},
      tableData: [],
      total: 0,
      dialogVisible: false,
      loading: false,
      submiting: false,
      currentPage4: 1,
      pageSize: 10,
      statelist: [
        { id: "a", name: "Vip学生" },
        { id: "s", name: "Vip研究生" },
      ], //状态
      heighDialogVisible: false, //升学体验
    };
  },
  created() {
    // 列表
    this.getList();
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.currentPage41;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.getList();
    },
    //查询
    selClick() {
      this.currentPage4 = 1;
      this.getList();
    },
    //列表方法
    getList() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getStudent_Exprience("GetList_StuExprience");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 编辑申请体验
    editClick(row, state) {
      var _this = this;
      var id = row.id;
      if (state == 1) {
        _this.dialogVisible = true;
      } else {
        _this.heighDialogVisible = true;
      }
      var link = url.getStudent_Exprience("GetModel_StuExp");
      $.get(link, { id: id }, (res) => {
        _this.form = res;
      });
    },
    // 提交申请体验
    submitForm(formName, type) {
      var _this = this;
      var link = url.getStudent_Exprience("Update_StuExprience");
      var info = this.form;
      if (info.applyContent) {
        info.isApplyFill = true;
      } else {
        info.isApplyFill = false;
      }
      if (info.heighContent) {
        info.isHeighFill = true;
      } else {
        info.isHeighFill = false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              if (type == 1) {
                _this.dialogVisible = false;
              } else {
                _this.heighDialogVisible = false;
              }
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 提交升学体验
    heighSubmitForm(formName) {},
  },
};
</script>